export default __webpack_public_path__ + "static/media/7.311e4cb0.jpeg";